module.exports = {
    API_TITLE:"驿企惠数智化采购平台", //项目名称
    testdomainName:"https://api.yiqihui.cloud/", //测试域名
    domainName:"https://api.yiqihui.cloud/", //正式域名
    interfacePrefix:"api/", //接口前缀
    port:8070, //本地端口
    assetsPublicPath:"/", //打包后服务器文件路径
}


//////////////////
// WEBPACK FOOTER
// ./vue.config.js
// module id = D/cJ
// module chunks = 61